// Système d'événements pour rafraîchir les données après modifications dans l'admin
import { useEffect } from 'react';

// Événements personnalisés pour déclencher le rafraîchissement
export const REFRESH_EVENTS = {
  SERVICES: 'refresh-services',
  PRICING: 'refresh-pricing',
  SETTINGS: 'refresh-settings',
  CONTACTS: 'refresh-contacts',
  ABOUT: 'refresh-about',
  HOME: 'refresh-home'
};

// Émettre un événement de rafraîchissement
export const triggerRefresh = (eventType) => {
  const event = new CustomEvent(eventType, {
    detail: { timestamp: Date.now() }
  });
  window.dispatchEvent(event);
  console.log(`🔄 Événement de rafraîchissement déclenché: ${eventType}`);
};

// Hook personnalisé pour écouter les événements de rafraîchissement
export const useRefreshListener = (eventType, refreshCallback) => {
  useEffect(() => {
    const handleRefresh = () => {
      console.log(`📡 Événement reçu: ${eventType}, rafraîchissement en cours...`);
      refreshCallback();
    };

    window.addEventListener(eventType, handleRefresh);
    
    return () => {
      window.removeEventListener(eventType, handleRefresh);
    };
  }, [eventType, refreshCallback]);
};

